module.exports = __webpack_public_path__ + "static/media/TourRequests.6b76ab65.svg";